// What the user is making. Picking an intent narrows which dimensions the score grades —
// e.g. an instrumental track isn't docked for "missing vocals". The backend owns the actual
// graded sets (PromptHints::Analyzer::INTENTS) and returns `requiredDimensions`; this is just
// the picker's display metadata. Keys MUST match the Ruby INTENTS keys.
export interface Intent {
  key: string
  label: string
  icon: string
  hint: string
}

export const INTENTS: Intent[] = [
  { key: 'full_song', label: 'Full song', icon: '🎵', hint: 'Vocals, beat, the works.' },
  { key: 'instrumental', label: 'Instrumental', icon: '🎹', hint: 'No lead vocals expected.' },
  { key: 'cinematic', label: 'Cinematic', icon: '🎬', hint: 'Score & texture; beat and vocals optional.' },
  { key: 'acapella', label: 'A cappella', icon: '🎤', hint: 'Voice-forward; instruments optional.' },
]

export const DEFAULT_INTENT = 'full_song'
